import React, { Component } from "react";
import { connect } from "react-redux";
import * as components from "Redux_Api_Middleware";
import * as contextSelectors from "../selectors/context";

const branch = (WrappedComponent) => {
	class Branch extends Component {
		render() {
			return <WrappedComponent {...this.state} {...this.props} />;
		}
	}

	const mapStateToProps = (state) => {
		return {
			cartReducer: state.cartReducer,
			voucherReducer: state.voucherReducer,
			cartResourcesReducer: state.cartResourcesReducer,
			cartSettingsReducer: state.cartSettingsReducer,
			settings: contextSelectors.getSettings(state),
			errors: components.selectors.getErrors(state)
		};
	};

	return connect(mapStateToProps)(Branch);
};

export default branch;
